import React from "react"
import MuiButton from "@mui/material/Button"

interface ButtonProps {
    /**
     * adds additional class names
     */
    className?: string
    /**
     * content inside the button
     */
    children?: React.ReactNode
    /**
     * click handler
     */
    onClick?: (event?: any) => void
    /**
     * button type
     */
    type?: "button" | "submit" | "reset"
    /**
     * for integration testing
     */
    testId?: string
    /**
     * makes the button take full width
     */
    block?: boolean
    /**
     * disables the button
     */
    disabled?: boolean
    /**
     * optional value attribute
     */
    value?: string
    /**
     * inline styles
     */
    style?: React.CSSProperties
}

const Button: React.FC<ButtonProps> = ({
                                           className,
                                           children,
                                           onClick,
                                           type = "button",
                                           testId,
                                           block,
                                           disabled,
                                           value,
                                           style,
                                       }) => {
    return (
        <MuiButton
            variant="contained"
            type={type}
            onClick={onClick}
            disabled={disabled}
            value={value}
            fullWidth={block}
            style={{
                maxWidth:"100%",
                backgroundColor:disabled ? "#94ADEB" : "#2b5dd8",
                border: 0,
                color: "#fff",
                fontFamily: "Helvetica Neue, sans-serif",
                fontSize: "14px",
                fontWeight: 700,
                letterSpacing: "1px",
                lineHeight: "17px",
                textAlign: "center",
                ...(style || {}) // spread custom style if passed
            }}
            className={className}
            data-tst-id={testId}
        >
            {children}
        </MuiButton>
    )
}

export default Button
